<section class="width-100">
  <mat-checkbox color="primary"
                [formControl]="checkFormControl"
                [indeterminate]="indeterminate"
                [required]="required">
    {{label}}
  </mat-checkbox>
</section>
